// The websocket (repository event, stored and replayed in the history) keeps the flat shape {...data, type} of the
// messages that are {type, data} on the P2P/SFU data channel
export const toWsMessage = ({type, data}) => ({...data, type})
